import Vue from 'vue'
Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('thousandSeparator', thousandSeparator)
Vue.filter('shortNumber', kmbFormatter)

var moment = require('moment');
moment.tz = require('moment-timezone');
function thousandSeparator(nStr) {
    nStr += '';
    var x = nStr.split(',');
    var x1 = x[0];
    var x2 = x.length > 1 ? ',' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}

function kmbFormatter(num) {
    let kmb;
    if (Math.abs(num) > 999999) {
      kmb = Math.sign(num)*((Math.abs(num)/1000000).toFixed(1));
      kmb = thousandSeparator(kmb.toString().replace('.', ','));
      kmb = thousandSeparator(kmb)  + 'm';
    }else if(Math.abs(num) > 999){
      kmb = Math.sign(num)*((Math.abs(num)/1000).toFixed(1));
      kmb = thousandSeparator(kmb.toString().replace('.', ','));
      kmb = thousandSeparator(kmb) + 'k';
    }else {
      kmb = Math.sign(num)*Math.abs(num);
      if (kmb % 1 != 0) {
        kmb = kmb.toFixed(2)
      }
    }
    return kmb;
}

function dateConvert(tgl, format){
  if(!format){
    format = 'DD MMM YYYY'
  }
  let date_format = moment(tgl)
  return date_format.format(format)
}
Vue.filter('dateConvert', dateConvert)